(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvAcnInput', drvAcnInput);

    drvAcnInput.$inject = [];

    /**
     * @ngdoc directive
     * @name drvAcnInput
     * @description Acn input which includes validation.
     *
     * @param {string} value - Acn
     * @param {object} field - An entity field object
     */
    function drvAcnInput() {
        drvAcnInputCtrl.$inject = [];

        return {
            templateUrl: 'app/fieldinput/acn-input.tmpl.html',
            require: "ngModel",
            scope: {
            },
            controller: drvAcnInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '='
            },
            link: link
        };

        function drvAcnInputCtrl() {
            /* jshint validthis:true */
            var drvCtrl = this;
            drvCtrl.validateAcn = validateAcn;

            /*
             * Check to see if the Acn is valid
             */
            function validateAcn(acn) {
                var valid = false;

                if (!_.isNil(acn) && acn !== '') {
                    if (acn.length == 9 && !isNaN(acn)) {
                        var sumTotal = 0;

                        for (var i = 0; i < 8; i++) {
                            var digitInt = parseInt(acn[i]);

                            sumTotal += digitInt * getWeighting(i);
                        }

                        var modulo = sumTotal % 10;
                        var checkDigit = modulo == 10 ? 0 : 10 - modulo;

                        valid = checkDigit == parseInt(acn[8]);
                    }
                } else {
                    valid = true;
                }

                return valid;
            }

            function getWeighting(index) {
                var result;

                switch (index) {
                    case 0:
                        result = 8;
                        break;
                    case 1:
                        result = 7;
                        break;
                    case 2:
                        result = 6;
                        break;
                    case 3:
                        result = 5;
                        break;
                    case 4:
                        result = 4;
                        break;
                    case 5:
                        result = 3;
                        break;
                    case 6:
                        result = 2;
                        break;
                    case 7:
                        result = 1;
                        break;
                }

                return result;
            }
        }
    }

    /*
     * Link function which will handle validation
     */
    function link($scope, $element, $attrs, $ctrl) {
        $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
            return $scope.drvCtrl.validateAcn(modelValue);
        };
    }
})();